import React, { useMemo } from 'react'
import { pages } from '../../pages/pages'
import { useLocation, useParams } from 'react-router'

import { SidebarItemProps } from './SidebarItem.props'
import { SidebarProps } from './Sidebar.props'

import ChevronsSidebar from 'assets/icon/chevrons-sidebar.svg'
import ClientListIcon from 'assets/icon/client-list.svg'
import NewBookingIcon from 'assets/icon/new-booking.svg'
import EmailOutreachIcon from 'assets/icon/email-outreach.svg'
import TextOutreachIcon from 'assets/icon/chat-outreach.svg'
import ProgramsIcon from 'assets/icons/program.svg'
import ReceiptsIcon from 'assets/icons/receipts.svg'
import WaiverSigneesIcon from 'assets/icon/waiver-signees.svg'
import FacilityOperationsIcon from 'assets/icon/facility-operation.svg'
import ProgramHomeIcon from 'assets/icons/home.svg'
import CalendarIcon from 'assets/icons/calendar-sidebar-icon.svg'
import BoltIcon from 'assets/icons/bolt.svg'
import ReportIcon from 'assets/icons/report.svg'

import SidebarItem from './SidebarItem'

import {
  SidebarContainer,
  SidebarMenu,
  SidebarButton,
  // SidebarAvatarContainer,
} from './Sidebar.styled'
import { SidebarItemIcon } from './SidebarItem.styled'
import { Location } from 'models/location'
// import UploadFile from 'components/UploadFile'
// import { ProfileAvatar } from 'pages/Profile/Profile.styled'
// import Avatar from 'assets/images/avatar.png'

const Sidebar: React.FC<SidebarProps> = ({
  toggleSidebar,
  sidebarOpen,
  type,
}) => {
  const location = useLocation()
  const params: Location = useParams()
  // const [file, setFile] = useState<
  //   string | ArrayBuffer | File | null | undefined
  // >(null)

  const facilityItems = useMemo<SidebarItemProps[]>(
    () =>
      [
        {
          icon: () => <SidebarItemIcon src={NewBookingIcon} />,
          label: 'New Bookings',
          href: pages.Facilities.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={ClientListIcon} />,
          label: 'Clientlist',
          href: pages.Clientlist.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={ReportIcon} />,
          label: 'Reports',
          href: pages.Reports.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={EmailOutreachIcon} />,
          label: 'Email Outreach',
          href: pages.EmailOutreach.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={TextOutreachIcon} />,
          label: 'Text Outreach',
          href: pages.TextOutreach.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={ProgramsIcon} />,
          label: 'Programs',
          href: pages.Programs.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={WaiverSigneesIcon} />,
          label: 'Waiver Signees',
          href: pages.WaiverSignees.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={FacilityOperationsIcon} />,
          label: 'Facility Operations',
          href: pages.FacilityOperations.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={CalendarIcon} />,
          label: 'Discarded Appointment',
          href: pages.DiscardedAppointment.url(params ? params.locationId : ''),
        },
      ].map(item => ({
        ...item,
        isActive: location.pathname === item.href ? true : false,
      })),
    [location]
  )

  const profileItems = useMemo<SidebarItemProps[]>(
    () =>
      [
        {
          icon: () => <SidebarItemIcon src={ProgramHomeIcon} />,
          label: 'My Facility',
          href: pages.MyFacility.url(),
        },
        {
          icon: () => <SidebarItemIcon src={CalendarIcon} />,
          label: 'Appointments',
          href: pages.Facilities.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={ReceiptsIcon} />,
          label: 'Receipts',
          href: pages.Facilities.url(params ? params.locationId : ''),
        },
        {
          icon: () => <SidebarItemIcon src={BoltIcon} />,
          label: 'Roaming Pro',
          href: pages.Facilities.url(params ? params.locationId : ''),
        },
      ].map(item => ({
        ...item,
        isActive: location.pathname === item.href ? true : false,
      })),
    [location]
  )

  if (location.pathname.includes(pages.Profile.path)) {
    return null
  }

  return (
    <SidebarContainer sidebarOpen={sidebarOpen}>
      {/* {type === 'profile' && (
        <SidebarAvatarContainer>
          <ProfileAvatar src={file ? file : Avatar} />
          <UploadFile
            text={'Change Profile Image'}
            accept={'.png, .jpg, .jpge'}
            onUploaded={setFile}
          />
        </SidebarAvatarContainer>
      )} */}
      <SidebarMenu>
        {type === 'facility' &&
          facilityItems.map(item => <SidebarItem key={item.label} {...item} />)}
        {type === 'profile' &&
          profileItems.map(item => <SidebarItem key={item.label} {...item} />)}
      </SidebarMenu>
      <SidebarButton
        onClick={toggleSidebar}
        sidebarOpen={sidebarOpen}
        onMouseEnter={toggleSidebar}>
        <img src={ChevronsSidebar} alt="ChevronsSidebar icon" />
      </SidebarButton>
    </SidebarContainer>
  )
}

export default Sidebar
